export default "__VITE_ASSET__CkKqMXp1__"